"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BluetoothCodesMap = new Map([
    [0, 'Pairing Success'],
    [1, 'Pairing Failed'],
    [2, 'User created bond'],
    [3, 'Pairing window timeout'],
]);
exports.default = BluetoothCodesMap;
